import { useSessionStorage } from 'react-use';

// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useLatestContainerRentOrderIds() {
    const [latestOrderIds, storeLatestOrderIds] = useSessionStorage<string[]>('container_rent.order_ids', []);

    return {
        latestOrderIds,
        storeLatestOrderIds,
    };
}
